import React from 'react'

const FeedListItemLoader = () => (
  <div className="loader feed-list-item-loader">
    <div
      className="loader-row"
      style={{
        width: 41,
        height: 41,
        borderRadius: '50%',
        marginRight: 16,
      }}
    />
    <div style={{ flexGrow: 1 }}>
      <div
        className="loader-row"
        style={{
          width: '50%',
          height: 13,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: '70%',
          height: 13,
          marginTop: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: '60%',
          height: 13,
          marginTop: 5,
        }}
      />
    </div>
    <div
      className="loader-row"
      style={{
        position: 'absolute',
        top: 15,
        right: 0,
        width: 50,
        height: 12,
      }}
    />
  </div>
)

FeedListItemLoader.displayName = 'FeedListItemLoader'

export default FeedListItemLoader
